Apt.fn.make('account.listings', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;

		priv.initFilters();
		priv.initTabs();

		LS.util.load('account-post');
	},

	/**
	 * Initialize action
	 *
	 * @param {Object} app
	 * @param {String} namespace
	 * @param {$} [delegate]
	 */
	initAction(app, namespace, delegate) {
		const $action = $$('listingAction');

		$action.on('input', (e, el) => {
			const action = el.value;

			if (! action) {
				return;
			}

			const id = $(el).closest('[data-id]')
				.data('id');

			let query;

			el.value = '';

			if (delegate) {
				query = {
					'results.id': id
				};
			}

			if (
				action === 'promote' ||
				action === 'demote'
			) {
				const promote = action === 'promote';

				LS.api.request(`me/listings/${id}/promote`, {
					auth: true,
					method: 'patch',
					data: {
						listing: {
							promoted: promote
						}
					},
					namespace: namespace,
					success: () => {
						app.$set(
							['promoted', query], promote
						);
					}
				});

				return;
			}

			if (action === 'price') {
				const current = LS.util.parseNumber(
					app.$get(['price', query])
				);

				LS.modal.open({
					width: 360,
					model: {
						title: 'Edit price',
						content: $.view.render('account-listings.price', {
							price: current
						})
					},
					onShow: () => {
						const $form = $$('priceForm');

						LS.util.restrict('[inputmode]', () => {}, 'price', $form);

						$form.on('submit', (e, el) => {
							const updated = el.price.value;

							if (current && updated && Math.abs((LS.util.parseNumber(updated) - current) / current) > 0.5) {
								LS.util.warn('Price change requires verification — contact support', {
									id: id,
									price: updated
								});

								return;
							}

							LS.modal.confirm(`Change the price from ${current ? LS.util.formatCurrency(current) : 'empty'} to ${LS.util.formatCurrency(updated)}?`, () => {
								LS.api.request(`me/listings/${id}/price`, {
									auth: true,
									method: 'patch',
									data: {
										listing: {
											price: updated
										}
									},
									namespace: 'price',
									success: () => {
										app.$set(
											['price', query], updated ?
												LS.util.formatCurrency(updated) : updated
										);
									}
								});
							});
						}, {
							cancel: true,
							namespace: 'price'
						});
					},
					onHide: () => {
						$.events.reset('price');
					}
				});

				return;
			}

			if (action === 'renew') {
				LS.modal.confirm('Is the listing still active and up to date?', () => {
					LS.api.request(`me/listings/${id}/renew`, {
						auth: true,
						method: 'patch',
						namespace: namespace,
						success: data => {
							data.renew = false;

							query ?
								app.$set(query, data) :
								app.$merge(data);
						}
					});
				});

				return;
			}

			let message = `Change the status from ${app.$get(['status', query])} to ${action}?`;

			if (action === 'closed') {
				message += ' Only select on final, completed transactions.'
			}

			LS.modal.confirm(message, () => {
				LS.api.request(`me/listings/${id}/status`, {
					auth: true,
					method: 'patch',
					data: {
						listing: {
							status: action
						}
					},
					namespace: namespace,
					success: data => {
						query ?
							app.$merge(query, data) :
							app.$merge(data);
					}
				});
			});
		}, {
			delegate: delegate,
			namespace: namespace
		});

		const query = $.routes.parse().query;

		if (query.action && $(`option[value="${query.action}"]`, $action).length) {
			$action.val(query.action)
				.trigger('input');
		}
	},

	/**
	 * Transform listing
	 *
	 * @param {Object} listing
	 */
	transform(listing) {
		listing.archived = Boolean(listing.archived_at);
		listing.syndicated = listing.source !== 'direct';

		listing.promotable = listing.promoted ||
			listing.status === 'active' ||
			listing.status === 'pending';

		listing.actionable = listing.promotable || ! listing.syndicated;

		listing.listed_at = LS.util.localize(listing.listed_at)
			.toISOString();

		if (listing.expired_at || listing.expires_at) {
			listing.renew = true;
		}

		if (! listing.approved || ! listing.visible) {
			listing.path = `/account/listings/${listing.id}/preview`
		}
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('listings', this.$private, [
			'app',
			'calls',
			'filters',
			'messages',
			'metrics'
		]);
	}
}, {
	/**
	 * Initialize filters
	 */
	initFilters() {
		const scope = this;
		const $filters = $$('filters');

		scope.feed = LS.filters.get('feed');
		scope.team = LS.filters.get('team');
		scope.user = LS.filters.get('user');

		scope.feed = scope.feed ?
			Number(scope.feed) : '';
		scope.team = scope.team ?
			Number(scope.team) : '';
		scope.user = scope.user ?
			Number(scope.user) : '';

		scope.filters = $.app.make('teams', {
			view: $$('filtersTemplate')[0].textContent,
			target: $filters,
			model: {
				user: scope.user
			}
		});

		if (scope.team) {
			scope.loadUsers(scope.team);
		}

		$.events.on({
			'$source': {
				change: (e, el) => {
					let id = el.value;
					let type;

					if (id) {
						const parts = id.split('-');

						type = parts[0];
						id = Number(parts[1]);
					}

					scope.setSource(type, id, true);
				}
			},
			'$user': {
				change: (e, el) => {
					scope.user = el.value ?
						Number(el.value) : '';

					scope.filters.$set('user', scope.user);

					scope.getApp().filter({
						user: scope.user
					}, null, {
						scrollTop: false
					});
				}
			}
		}, {
			delegate: $filters,
			namespace: 'listings'
		});

		LS.api.get('me/teams', {
			auth: true,
			data: {
				role: [
					'admin',
					'owner'
				]
			},
			success: data => {
				const teams = data.results;

				scope.teams = LS.util.key(teams);

				if (! teams || ! teams.length) {
					return;
				}

				scope.filters.$merge({
					delegate: true,
					teams: teams
				});

				if (scope.team) {
					scope.setSource('team', scope.team);
				}
			}
		});

		LS.api.get('me/feeds', {
			auth: true,
			success: data => {
				const feeds = data.results;

				scope.feeds = LS.util.key(feeds);

				if (! feeds || ! feeds.length) {
					return;
				}

				scope.filters.$merge({
					delegate: true,
					feeds: feeds
				});

				if (scope.feed) {
					scope.setSource('feed', scope.feed);
				}
			}
		});
	},

	/**
	 * Set source
	 *
	 * @param {String} type
	 * @param {Number} id
	 * @param {Boolean} [filter=false]
	 */
	setSource(type, id, filter) {
		const scope = this;
		const filters = {
			feed: '',
			team: '',
			user: ''
		};

		if (type === 'team') {
			filters.team = id;

			scope.loadUsers(id);
		} else {
			if (type === 'feed') {
				filters.feed = id;
			} else {
				filters.user = id;
			}

			scope.filters.$drop('users');
		}

		scope.filters.$merge({
			user: scope.user
		});

		scope.feed = filters.feed;
		scope.team = filters.team;
		scope.user = filters.user;

		if (filter) {
			scope.getApp().filter(filters, null, {
				scrollTop: false
			});
		}

		$$('source').val(id ? type + '-' + id : '');
	},

	/**
	 * Initialize tabs
	 */
	initTabs() {
		const scope = this;
		const init = {};

		scope.tabs = Apt.fn.tab()
			.init('$tabs', id => {
				scope.active = id;

				const app = scope.getApp();

				if (app) {
					scope.getApp().filter({
						team: scope.team,
						user: scope.user
					}, null, {
						scrollTop: false
					});
				}

				if (init[id]) {
					return;
				}

				init[id] = true;

				scope['init' + LS.util.capitalize(id)]();
			});
	},

	/**
	 * Initialize manage
	 */
	initManage() {
		const scope = this;
		const $controls = $$('controls');
		const app = 'listings';

		scope.app = Apt.fn.index().init({
			app: app,
			auth: true,
			view: $$('template')[0].textContent,
			path: 'account/listings',
			resource: 'me/listings',
			controls: $controls,
			paginate: true,
			params: {
				limit: 10
			},
			model: {
				label: 'property'
			},
			sorting: {
				'-newest': 'Newest',
				'newest': 'Oldest',
				'-price': 'Price: high to low',
				'price': 'Price: low to high',
				'-size': 'Size: large to small',
				'size': 'Size: small to large'
			},
			build: filters => {
				if ($$('promoted').prop('checked')) {
					filters.promoted = 1;
				}
				else {
					delete filters.promoted;
				}
			},
			translate: filters => {
				if (! $$('promoted').prop('checked')) {
					delete filters.promoted;
				}
			},
			transform: listing => {
				Apt.properties.transform(listing);

				scope.$public.transform(listing);
			}
		}, () => {
			scope.$public.initAction(scope.app.app, 'listings', '$results');
		});

		$('$status, $promoted').on('change', () => {
			$controls.trigger('submit');
		}, {
			namespace: 'listings'
		});
	},

	/**
	 * Load agents
	 *
	 * @param {Number} team
	 */
	loadUsers(team) {
		const scope = this;

		LS.api.get(`me/teams/${team}/users`, {
			auth: true,
			data: {
				limit: null
			},
			success: data => {
				scope.filters.$drop('users');

				scope.filters.$set('users', data.results);
			}
		});
	},

	/**
	 * Initialize messages
	 */
	initMessages() {
		const scope = this;

		LS.util.load('account-messages', () => {
			scope.messages = Apt.fn['account.messages']()
				.init({
					path: 'me/listings',
					empty: 'No matching listing messages were delivered.',
					sender: true,
					static: true,
					target: true,
					filters: {
						feed: scope.feed,
						team: scope.team,
						user: scope.user
					}
				});
		});
	},

	/**
	 * Initialize calls
	 */
	initCalls() {
		const scope = this;

		LS.util.load('account-calls', () => {
			scope.calls = Apt.fn['account.calls']()
				.init({
					path: 'me/listings',
					empty: 'No matching listing calls were dialed.',
					caller: true,
					static: true,
					target: true,
					filters: {
						feed: scope.feed,
						team: scope.team,
						user: scope.user
					}
				});
		});
	},

	/**
	 * Initialize metrics
	 */
	initMetrics() {
		const scope = this;

		LS.util.load('account-metrics', () => {
			scope.metrics = Apt.fn['account.metrics']()
				.init({
					columns: 4,
					path: 'me/listings',
					filters: {
						feed: scope.feed,
						team: scope.team,
						user: scope.user
					}
				});
		});
	},

	/**
	 * Get active app
	 *
	 * @returns {Object}
	 */
	getApp() {
		const scope = this;
		const active = scope.active;

		if (active === 'messages') {
			if (! scope.messages) {
				return null;
			}

			return scope.messages.app;
		}

		if (active === 'calls') {
			if (! scope.calls) {
				return null;
			}

			return scope.calls.app;
		}

		if (active === 'metrics') {
			if (! scope.metrics) {
				return null;
			}

			return scope.metrics.app;
		}

		return scope.app;
	}
});